/**
 * VEXIL menu failsafe
 * Only registers when global.js did not register the theme drawers.
 * Keeps the mobile/desktop burger usable even if another earlier script aborts.
 */
(() => {
  'use strict';

  class VexilFallbackMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.vexilFallbackBound === 'true') return;
      this.dataset.vexilFallbackBound = 'true';

      this.mainDetailsToggle = this.querySelector(':scope > details');
      if (!this.mainDetailsToggle) return;

      this.mainSummary = this.mainDetailsToggle.querySelector(':scope > summary');
      if (!this.mainSummary) return;

      this.mainSummary.setAttribute('role', 'button');
      this.mainSummary.setAttribute(
        'aria-expanded',
        this.mainDetailsToggle.hasAttribute('open') ? 'true' : 'false',
      );

      this.mainSummary.addEventListener('click', (event) => {
        event.preventDefault();
        this.mainDetailsToggle.hasAttribute('open') ? this.close() : this.open();
      });

      this.querySelectorAll('.menu-drawer__close-button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close(true);
      });
    }

    open() {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainSummary.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint || 'tablet'}`);
    }

    close(focusSummary = false) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainSummary.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint || 'tablet'}`);

      // Match the theme's closing animation before removing the native open state.
      window.setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        if (focusSummary) this.mainSummary.focus();
      }, 400);
    }
  }

  class VexilFallbackHeaderDrawer extends VexilFallbackMenuDrawer {}

  if (!customElements.get('menu-drawer')) {
    customElements.define('menu-drawer', VexilFallbackMenuDrawer);
  }
  if (!customElements.get('header-drawer')) {
    customElements.define('header-drawer', VexilFallbackHeaderDrawer);
  }
})();
